'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './project-board.routes';

export class ProjectBoardComponent {
  constructor($stateParams, ProjectService, ProjectItemService, $uibModal, $window, dialogs, RecentVisits, PinnedItems,
              DTOptionsBuilder, DTState) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.projectId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;

    this.tasks = [];
    this.activities = [];

    this.asTable = false;

    this.ProjectService = ProjectService;
    this.ProjectItemService = ProjectItemService;

    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;
    this.DTOptionsBuilder = DTOptionsBuilder;

    this.refreshData(true);

    this.persistOrder = event => {
      let sourceColumnIndex =  event.source.sortableScope.element[0].getAttribute('column-idx');
      let destColumnIndex = event.dest.sortableScope.element[0].getAttribute('column-idx');

      let sourceItemIndex = event.source.index;
      let destItemIndex = event.dest.index;

      this.ProjectService.patch({id: this.projectId}, [
        { "op": "move", "from": "/columns/"+sourceColumnIndex+"/items/"+sourceItemIndex, "path": "/columns/"+destColumnIndex+"/items/"+destItemIndex }
      ], _ => {
        this.refreshData();
      }, err => {
        console.log('Could not update project');
      });
    };

    this.dragControlListeners = {
      accept: function (sourceItemHandleScope, destSortableScope) {
        return true;
      },
      itemMoved: this.persistOrder,
      orderChanged: this.persistOrder
    };

    this.dropdownmenu = [{
      title: 'Edit',
      icon: 'pencil',
      action: item => {
        this.openEditProjectItemModal(item);
      }
    },{
      title: 'Delete',
      icon: 'trash',
      action: item => {
        this.delete(item);
      }
    }/*,{
      title: 'Move to (Sub-)Project',
      icon: 'arrow-right',
      action: _ => {
        alert('move')
      }
    },{
     title: 'Assign',
     icon: 'user-plus',
     action: _ => {
     alert('assign')
     }
     },{
     "title": "Log Work",
     "icon": "clock-o",
     action: _ => {
     alert('log work')
     }
     },{
     title: 'Share',
     icon: 'share',
     action: _ => {
     alert('share')
     }
     }*/];

  }

  setAsTable(val) {
    if (val == true) {
      this.items = [];
      this.project.columns.forEach(column => {
        column.items.forEach(item => {
          let _item = angular.copy(item);
          _item.state = column.name;
          _item.color = column.color;
          this.items.push(_item);
        });
      });
      console.log(this.items);
    }

    this.asTable = val;
    //this.$localStorage.vendorListAsTable = val;
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.ProjectService.addAttachments({id: that.projectId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to project');
        });
      },
      function () { /* cancel */ }
    );

  }


  calcPercentageProject() {

    let sumTarget = 0;
    let sumActual = 0;

    this.project.columns.forEach(column => {
      column.items.forEach(item => {

        if (item.progressTarget) {

          sumTarget += item.progressTarget;

          if (item.progressActual) {

            if (item.progressActual > item.progressTarget) {
              sumActual += item.progressTarget;
            } else {
              sumActual += item.progressActual;
            }

          }

        }

      })
    });

    if (sumTarget == 0)
      return 0;

    let percent = (sumActual / sumTarget) * 100;

    return percent.toFixed(0);
  }

  refreshData(init) {
    if (this.projectId) {
      this.ProjectService.get({id: this.projectId}, data => {
        this.project = data;
        this.project.progress = this.calcPercentageProject();

        this.RecentVisits.addProject(this.projectId, this.project.name);
        this.isPinned = this.PinnedItems.isPinnedProject(this.projectId);

        if (init) {
          this.dtOptions = this.DTOptionsBuilder
            .newOptions()
            .withOption('dom', 'lBfrtip')
            //.withOption('stateSave',true)
            //.withOption('stateSaveCallback', DTState.save())
            //.withOption('stateLoadCallback', DTState.restore())
            .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withOption('rowGroup', {
              dataSrc: [1]
            })
            .withOption('columnDefs', [{
              targets: [0, 1],
              visible: false
            }])
            .withOption('buttons',[{
              extend: 'excel',
              title: this.project.name
            },{
              extend: 'csv',
              title: this.project.name
            },{
              title: this.project.name,
              message: 'As of ' + moment().format("MMMM Do YYYY"),
              extend: 'pdf',
              orientation: 'portrait',
              pageSize: 'LETTER'
            },{
              extend: 'print',
              title: this.project.name
            }]);
        }

        if (!init)
          this.ProjectService.patch({id: this.projectId}, [
            { "op": "add", "path": "/progress", "value": this.project.progress }
          ]);

        }, err => {
        console.log('Could not load project from server');
      });
    }
  }

  openEditProjectItemModal(item) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'projectItemEdit',
      resolve: {
        config: function() {
          return {
            data: item
          }
        }
      }
    });

    modalInstance.result.then(projectItem => {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  openNewProjectItemModal(columnIndex) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'projectItemEdit',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(projectItem => {
        this.ProjectService.patch({id: this.projectId}, [ { "op": "add", "path": "/columns/"+columnIndex+"/items/-", "value": projectItem._id } ], _ => {
          that.refreshData();
        }, err => {
          console.log('Could not update project');
        });
      },
      function () { /* cancel */ }
    );

  }

  delete(card) {
    var that = this;

    let cardIndex = -1;
    let columnIndex = -1;

    for (let colIdx = 0; colIdx <= this.project.columns.length; colIdx++) {
      let _cardIndex = this.project.columns[colIdx].items.findIndex(item => card._id == item._id);

      if (_cardIndex !== -1) {
        cardIndex = _cardIndex;
        columnIndex = colIdx;
        break;
      }
    }

    if (cardIndex == -1 || columnIndex == -1) {
      console.log("Could not delete item");
      return;
    }

    var cardText = "<br/><br/><b>" + card.title + "</b><br/><p>" + card.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Project Item?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this project item?" + cardText);
    dlg.result.then(() => {

      // Patch the card away
      this.ProjectService.patch({id: this.projectId}, [ { "op": "remove", "path": "/columns/"+columnIndex+"/items/"+cardIndex } ], _ => {

        // OK delete the card itself
        that.ProjectItemService.delete({id: card._id},
          () => {
            that.refreshData();
          },
          err => {
            alert("Could not delete project item");
          });

      }, err => {
        console.log('Could not update project');
      });

    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduu.projectBoard', [uiRouter])
  .config(routes)
  .component('projectBoard', {
    template: require('./project-board.html'),
    controller: ProjectBoardComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/project/board/project-board.component.js